<template>

    <div class="">
      <div v-if="pagination.total > 0" class="row m-0">
        <div class="p-0" :class="center ? 'col-12' : 'col-6'">
          <ul v-if="pagination.last_page > 1" class="pagination pagination-rounded  m-0" :class="center ? 'justify-content-center' : 'justify-content-start'">
            <li v-if="pagination.current_page > 1" class="page-item _c-pointer"><a class="page-link _f-s-20" @click.prevent="changePage(1)" v-tippy content="Go to page 1"><div style="margin-top:-6px;">&laquo;</div></a></li>
            <li v-if="pagination.current_page > 1" class="page-item _c-pointer"><a class="page-link _f-s-20" @click.prevent="changePage(pagination.current_page - 1)" v-tippy content="Previous"><div style="margin-top:-6px;">&lsaquo;</div></a></li>
            <li v-for="page in pagesNumber" class="page-item _c-pointer" :class="{'active': page == pagination.current_page}"><a class="page-link" @click.prevent="changePage(page)">{{ page }}</a></li>
            <li v-if="pagination.current_page < pagination.last_page" class="page-item _c-pointer"><a class="page-link _f-s-20" @click.prevent="changePage(pagination.current_page + 1)" v-tippy content="Next"><div style="margin-top:-6px;">&rsaquo;</div></a></li>
            <li v-if="pagination.current_page < pagination.last_page" class="page-item _c-pointer"><a class="page-link _f-s-20" @click.prevent="changePage(pagination.last_page)" v-tippy :content="'Go to page '+ pagination.last_page"><div style="margin-top:-6px;">&raquo;</div></a></li>
          </ul>
        </div>
        <div class="p-0 py-1 small text-muted" :class="center ? 'col-12 text-center mt-2' : 'col-6 text-right'">
          Showing {{(pagination.from ? pagination.from : '0')}} to {{(pagination.to ? pagination.to : '0')}} of {{(pagination.total ? pagination.total : '0')}} entries
        </div>
      </div>
      <div v-else-if="pagination.total == 0" class="p-3 text-muted text-center">No results found</div>
    </div>
  
  
  </template>
  <script>
  
    export default{
      props: {
        pagination: {
            type: Object,
            required: true
        },
        offset: {
            type: Number,
            default: 4
        },
        center: {
          type: Boolean,
          default: false,
        }
      },
      computed: {
        pagesNumber() {
          if (!this.pagination.to) {
            return [];
          }
          let from = this.pagination.current_page - this.offset;
          if (from < 1) {
            from = 1;
          }
          let to = from + (this.offset * 2);
          if (to >= this.pagination.last_page) {
            to = this.pagination.last_page;
          }
          let pagesArray = [];
          for (let page = from; page <= to; page++) {
            pagesArray.push(page);
          }
            return pagesArray;
        }
      },
      methods : {
        changePage(page) {
          // window.scroll({top: 0, left: 0, behavior: 'smooth' });
          this.pagination.current_page = page;
          this.$emit('paginate');
        }
      }
    }
  </script>
  